frappe.provide("webshop.webshop.wishlist");
var wishlist = webshop.webshop.wishlist;

frappe.provide("webshop.webshop.shopping_cart");
var shopping_cart = webshop.webshop.shopping_cart;

const ws_escape_html = (value) => {
	if (frappe.utils && frappe.utils.escape_html) {
		return frappe.utils.escape_html(String(value || ""));
	}
	return $("<div>").text(value || "").html();
};

const ws_escape_url = (value) => ws_escape_html(encodeURI(value || "#").replace(/%25([0-9a-f]{2})/gi, "%$1"));

$.extend(wishlist, {
	set_wishlist_count: function(animate=false) {
		// set badge count for wishlist icon
		var wish_count = 0;
		if (frappe.session.user === "Guest") {
			wish_count = this.get_guest_wishlist().length;
		} else {
			wish_count = frappe.get_cookie("wish_count") || 0;
		}

		if (wish_count) {
			$(".wishlist").toggleClass('hidden', false);
		}

		var $wishlist = $('.wishlist-icon');
		var $badge = $wishlist.find("#wish-count");

		if (parseInt(wish_count) === 0 || wish_count === undefined) {
			$wishlist.css("display", "none");
		} else {
			$wishlist.css("display", "inline");
		}

		if (wish_count) {
			if ($badge.length === 0) {
				$wishlist.find('a').append('<span class="badge badge-danger shopping-badge" id="wish-count"></span>');
				$badge = $wishlist.find("#wish-count");
			}
			$badge.html(wish_count);
			if (animate) {
				$wishlist.addClass('cart-animate');
				setTimeout(() => {
					$wishlist.removeClass('cart-animate');
				}, 500);
			}
		} else {
			$badge.remove();
		}
	},

	get_guest_wishlist: function() {
		let list = localStorage.getItem("guest_wishlist");
		try {
			const parsed = list ? JSON.parse(list) : [];
			return Array.isArray(parsed) ? parsed.filter(code => typeof code === "string") : [];
		} catch (e) {
			localStorage.removeItem("guest_wishlist");
			return [];
		}
	},

	set_guest_wishlist: function(list) {
		localStorage.setItem("guest_wishlist", JSON.stringify(list));
	},

	bind_move_to_cart_action: function() {
		// move item to cart from wishlist
		$(document.body).off("click", ".btn-add-to-cart").on("click", ".btn-add-to-cart", (e) => {
			const $move_to_cart_btn = $(e.currentTarget);
			let item_code = $move_to_cart_btn.data("item-code");

			if ($move_to_cart_btn.prop("disabled")) return;
			$move_to_cart_btn.prop("disabled", true);
			const request = shopping_cart.update_cart({
				item_code,
				qty: $move_to_cart_btn.data("qty") || 1,
				uom: $move_to_cart_btn.data("uom"),
				with_items: 1,
				callback: (r) => {
					if (r.exc || !r.message) return;
					this.add_remove_from_wishlist("remove", {item_code}, () => {
						$move_to_cart_btn.closest(".wishlist-card").remove();
						const count = frappe.session.user === "Guest" ? this.get_guest_wishlist().length : frappe.get_cookie("wish_count") || 0;
						if (Number(count) === 0) this.render_empty_state();
					}, null, true);
				}
			});
			if (request && request.always) request.always(() => {
				$move_to_cart_btn.prop("disabled", false);
				shopping_cart.unfreeze();
			});
		});
	},

	bind_remove_action: function() {
		// remove item from wishlist
		let me = this;
		$(document.body).off("click", ".remove-wish").on("click", ".remove-wish", (e) => {
			const $remove_wish_btn = $(e.currentTarget);
			let item_code = $remove_wish_btn.data("item-code");

			let success_action = function() {
				const $card_wrapper = $remove_wish_btn.closest(".wishlist-card");
				$card_wrapper.addClass("wish-removed");
				
				let count = 0;
				if (frappe.session.user === "Guest") {
					count = me.get_guest_wishlist().length;
				} else {
					count = frappe.get_cookie("wish_count") || 0;
				}

				if (count == 0) {
					$(".page_content .products-list").empty();
					me.render_empty_state();
				}
			};
			let args = { item_code: item_code };
			this.add_remove_from_wishlist("remove", args, success_action);
		});
	},

	bind_wishlist_action() {
		// 'wish'('like') or 'unwish' item in product listing
		$(document.body).off('click', '.like-action, .like-action-list').on('click', '.like-action, .like-action-list', (e) => {
			const $btn = $(e.currentTarget);
			this.wishlist_action($btn);
		});
	},

	wishlist_action(btn) {
		const $wish_icon = btn.find('.wish-icon');
		let item_code = btn.data('item-code');
		let me = this;

		if (frappe.session.user === "Guest") {
			let list = this.get_guest_wishlist();
			if ($wish_icon.hasClass('wished')) {
				// remove
				list = list.filter(i => i !== item_code);
				this.toggle_button_class($wish_icon, 'wished', 'not-wished');
				btn.removeClass("like-animate");
				btn.removeClass("like-action-wished");
			} else {
				// add
				if (!list.includes(item_code)) {
					list.push(item_code);
				}
				this.toggle_button_class($wish_icon, 'not-wished', 'wished');
				btn.addClass("like-animate");
				btn.addClass("like-action-wished");
			}
			this.set_guest_wishlist(list);
			this.set_wishlist_count(true);
			return;
		}

		let success_action = function() {
			webshop.webshop.wishlist.set_wishlist_count(true);
		};

		if ($wish_icon.hasClass('wished')) {
			// un-wish item
			btn.removeClass("like-animate");
			btn.addClass("like-action-wished");
			this.toggle_button_class($wish_icon, 'wished', 'not-wished');

			let args = { item_code: item_code };
			let failure_action = function() {
				me.toggle_button_class($wish_icon, 'not-wished', 'wished');
			};
			this.add_remove_from_wishlist("remove", args, success_action, failure_action);
		} else {
			// wish item
			btn.addClass("like-animate");
			btn.addClass("like-action-wished");
			this.toggle_button_class($wish_icon, 'not-wished', 'wished');

			let args = {item_code: item_code};
			let failure_action = function() {
				me.toggle_button_class($wish_icon, 'wished', 'not-wished');
			};
			this.add_remove_from_wishlist("add", args, success_action, failure_action);
		}
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	add_remove_from_wishlist(action, args, success_action, failure_action, async=false) {
		if (frappe.session.user === "Guest") {
			let list = this.get_guest_wishlist();
			if (action === "add") {
				if (!list.includes(args.item_code)) list.push(args.item_code);
			} else {
				list = list.filter(i => i !== args.item_code);
			}
			this.set_guest_wishlist(list);
			this.set_wishlist_count(true);
			if (success_action) success_action();
		} else {
			let method = "webshop.webshop.doctype.wishlist.wishlist.add_to_wishlist";
			if (action === "remove") {
				method = "webshop.webshop.doctype.wishlist.wishlist.remove_from_wishlist";
			}

			frappe.call({
				async: async,
				type: "POST",
				method: method,
				args: args,
				callback: function (r) {
					if (r.exc) {
						if (failure_action && (typeof failure_action === 'function')) {
							failure_action();
						}
						frappe.msgprint({
							message: __("Sorry, something went wrong. Please refresh."),
							indicator: "red", title: __("Note")
						});
					} else if (success_action && (typeof success_action === 'function')) {
						success_action();
					}
				}
			});
		}
	},

	redirect_guest() {
		frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
			window.location.href = res.message || "/login";
		});
	},

	render_empty_state() {
		if ($("#sf-wishlist-empty").length) {
			$("#sf-wishlist-panel").empty();
			$("#sf-wishlist-empty").prop("hidden", false);
			return;
		}
		$(".page_content").html(`
			<div class="cart-empty frappe-card">
				<div class="cart-empty-state">
					<img src="/assets/webshop/images/cart-empty-state.png" alt="Empty Cart">
				</div>
				<div class="cart-empty-message mt-4">${ __('Wishlist is empty!') }</p>
			</div>
		`);
	},

	initialize_guest_wishlist_icons: function() {
		if (frappe.session.user !== "Guest") return;
		let list = this.get_guest_wishlist();
		$('.like-action, .like-action-list').each(function() {
			let item_code = $(this).data('item-code');
			if (list.includes(item_code)) {
				let $icon = $(this).find('.wish-icon');
				$icon.removeClass('not-wished').addClass('wished');
				$(this).addClass('like-action-wished');
			}
		});
	},

	render_guest_wishlist_page: function() {
		if (frappe.session.user !== "Guest" || window.location.pathname !== "/wishlist") return;
		
		let list = this.get_guest_wishlist();
		if (list.length === 0) {
			this.render_empty_state();
			return;
		}

		const modern = $("#sf-wishlist-panel").length > 0;
		const panel = modern ? "#sf-wishlist-panel" : ".page_content";
		$("#sf-wishlist-empty").prop("hidden", true);
		$(panel).html('<div class="text-center p-5"><div class="spinner-border text-primary" role="status"><span class="sr-only">' + __("Loading saved products") + '</span></div></div>');

		frappe.call({
			method: modern ? "webshop.storefront.customer.wishlist_items" : "webshop.webshop.api.get_wishlist_items_details",
			args: { item_codes: list },
			callback: (r) => {
				if (r.message && r.message.length > 0) {
					this.render_wishlist_items(r.message);
				} else {
					this.render_empty_state();
				}
			},
			error: (r) => {
				$(panel).html(`
					<div class="alert alert-danger m-5 text-center">
						${__("Failed to load wishlist items. Please try again later.")}
					</div>
				`);
			}
		});
	},

	render_wishlist_items: function(items) {
		if ($("#sf-wishlist-panel").length) {
			$("#sf-wishlist-empty").prop("hidden", true);
			$("#sf-wishlist-panel").html(`<div class="sf-wishlist-grid products-list">${items.map(item => this.get_modern_wishlist_card_html(item)).join("")}</div>`);
			return;
		}
		let html = `<div class="row">
			<div class="col-md-12 item-card-group-section">
				<div class="row products-list">`;
		
		items.forEach(item => {
			html += this.get_wishlist_card_html(item);
		});

		html += `</div></div></div>`;
		$(".page_content").html(html);
	},

	get_modern_wishlist_card_html: function(item) {
		const title = ws_escape_html(item.web_item_name || item.item_name || item.item_code);
		const code = ws_escape_html(item.item_code);
		const url = ws_escape_url(item.url);
		const media = item.image ? `<img src="${ws_escape_url(item.image)}" alt="${title}" width="600" height="600" loading="lazy">` : `<span class="sf-image-unavailable">${__("Image coming soon")}</span>`;
		const action = item.has_variants ? `<a class="sf-button sf-button--outline" href="${url}">${__("Choose options")}</a>` : item.can_add ? `<button type="button" class="sf-button sf-button--outline btn-add-to-cart" data-item-code="${code}" data-qty="${ws_escape_html(item.minimum_qty)}" data-uom="${ws_escape_html(item.uom)}">${__("Move to bag")}</button>` : `<a class="sf-button sf-button--outline" href="${item.formatted_price ? url : ws_escape_url(item.enquiry_url)}">${item.formatted_price ? __("View product") : __("Enquire about this product")}</a>`;
		return `<div class="wishlist-card"><article class="sf-product-card" data-item-code="${code}"><div class="sf-product-image"><a href="${url}" aria-label="${title}">${media}</a></div><div class="sf-product-copy"><h3><a href="${url}">${title}</a></h3><p class="sf-product-price ${item.formatted_price ? "" : "sf-price-enquiry"}">${ws_escape_html(item.formatted_price) || __("Price on enquiry")}</p>${action}</div></article><button type="button" class="remove-wish sf-text-link" data-item-code="${code}" aria-label="${__("Remove")}: ${title}">${__("Remove")}</button></div>`;
	},

	get_wishlist_card_html: function(item) {
		// Simplified version of the wishlist_card macro
		let item_code = ws_escape_html(item.item_code);
		let item_name = ws_escape_html(item.item_name);
		let web_item_name = ws_escape_html(item.web_item_name || item.item_name);
		let item_group = ws_escape_html(item.item_group);
		let route = ws_escape_url(item.route);
		let image_html = item.image ? 
			`<img itemprop="image" class="card-img" src="${ws_escape_url(item.image)}" alt="${web_item_name}">` :
			`<div itemprop="image" class="card-img-top no-image">${item.item_name ? ws_escape_html(item.item_name.substring(0,2).toUpperCase()) : 'NA'}</div>`;

		let price_html = `<div class="product-price">${ws_escape_html(item.formatted_price)}`;
		if (item.formatted_mrp) {
			price_html += `<small class="ml-1 striked-price"><s>${ws_escape_html(item.formatted_mrp)}</s></small>
						   <small class="ml-1 product-info-green">${ws_escape_html(item.discount)} OFF</small>`;
		}
		price_html += `</div>`;

		let action_html = item.available ? 
			`<button data-item-code="${item_code}" class="btn btn-primary btn-add-to-cart-list btn-add-to-cart mt-2 w-100">
				<span class="mr-2"><svg class="icon icon-md"><use href="#icon-assets"></use></svg></span>
				${__("Move to Cart")}
			</button>` :
			`<div class="out-of-stock">${__("Out of stock")}</div>`;

		return `
				<div class="col-sm-3 wishlist-card">
					<div class="card text-center">
						<div class="card-img-container">
							<a href="/${route}" style="text-decoration: none;">
								${image_html}
							</a>
							<div class="remove-wish" data-item-code="${item_code}">
								<svg class="icon icon-md remove-wish-icon">
								<use class="close" href="#icon-delete"></use>
							</svg>
							</div>
						</div>
						<div class="card-body card-body-flex text-left" style="width: 100%;">
							<div class="mt-4">
								<div class="product-title">${web_item_name || item_name}</div>
								<div class="product-category">${item_group || ''}</div>
							</div>
						${price_html}
						${action_html}
					</div>
				</div>
			</div>
		`;
	},

	bind_whatsapp_quote_action: function() {
		$(document.body).off("click", ".btn-wishlist-whatsapp").on("click", ".btn-wishlist-whatsapp", function() {
			const $btn = $(this);
			$btn.prop("disabled", true).text(__("Preparing..."));

			frappe.call({
				method: "webshop.webshop.api.get_wishlist_whatsapp_quote",
				callback: function(r) {
					$btn.prop("disabled", false).text(__("Send Wishlist on WhatsApp"));
					if (r.message && r.message.url) {
						window.open(r.message.url, "_blank", "noopener");
					}
				},
				error: function() {
					$btn.prop("disabled", false).text(__("Send Wishlist on WhatsApp"));
				}
			});
		});
	}
});

frappe.ready(function() {
	wishlist.set_wishlist_count();
	wishlist.initialize_guest_wishlist_icons();

	if (window.location.pathname === "/wishlist") {
		wishlist.bind_move_to_cart_action();
		wishlist.bind_remove_action();
		wishlist.bind_whatsapp_quote_action();
		if (frappe.session.user === "Guest") {
			wishlist.render_guest_wishlist_page();
		}
	} else {
		wishlist.bind_wishlist_action();
	}
});
